import { createContext, useContext, useReducer } from 'react';
import { DashboardState, DashboardReducer, ACTION_TYPES } from './dashboard-reducer';
import { Pagination } from '../../../../model/pagination';
import { IDashboardResponse } from '../../../../model/sdp/base/dashboard-response';
import { IOfficialDiaryPagedResponse } from '../../../../model/sdp/official-daily/response/official-diary-paged-response';
import { ISubimissonPublicationPagedResponse } from '../../../../model/sep/submission-publications/response/submissin-publication-paged-response';

const DashboardContext = createContext<DashboardState | undefined>(undefined);
const DashboardDispatchContext = createContext({} as any);

const DashboardProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: DashboardState = {
        dashboardDetail: {} as IDashboardResponse,
        officialDiaryItems: new Pagination<IOfficialDiaryPagedResponse>(),
        submissionPublicationItems: new Pagination<ISubimissonPublicationPagedResponse>(),
        tabIndex: 0,
        loading: false,
    };

    const [state, dispatch] = useReducer(DashboardReducer, initialState);

    return (
        <DashboardContext.Provider value={state}>
            <DashboardDispatchContext.Provider value={dispatch}>
                {children}
            </DashboardDispatchContext.Provider>
        </DashboardContext.Provider>
    );
}

const useDashboardState = () => {
    const context = useContext(DashboardContext);
    if (context === undefined) {
        throw new Error('useDashboardState must be used within a DashboardProvider');
    }
    return context;
}

const useDashboardDispatch = () => {
    const context = useContext(DashboardDispatchContext);
    if (context === undefined) {
        throw new Error('useDashboardDispatch must be used within a DashboardProvider');
    }
    return context;
}

export { DashboardProvider, useDashboardDispatch, useDashboardState, ACTION_TYPES };
